import React from 'react'
import { useLocale } from '../contexts/LocaleContext'

function DeleteAccount() {
  const { t } = useLocale()

  return (
    <div className="container section">
      <h1>{t.deleteAccount.title}</h1>
      <p>{t.deleteAccount.instructions} <a style={{textDecoration: 'underline'}} href={`mailto:${t.contact.email}`}>{t.contact.email}</a>
      </p>
    </div>
  )
}

export default DeleteAccount
